import * as React from "react";
import { FormComponentProps } from "antd/lib/form";
import { PbrInputMoney } from "src/components/common/PbrInputMoney/PbrInputMoney";
import { Col, Slider } from "antd";
import "./SliderMarkComponent.scss";
import { SliderMarks } from "antd/lib/slider";

interface ISliderMarkComponentProps extends FormComponentProps {
  title: string
  fieldName: string
  value: number
  minValue: number
  maxValue: number
  marks: SliderMarks
  needToPrecifyPercentLender: boolean
  isExceeding: boolean
  isVisible?: boolean
  handleChange: (value: number) => void
}

export const SliderMarkComponent: React.FC<ISliderMarkComponentProps> = ({
  title,
  value,
  marks,
  maxValue,
  minValue,
  form,
  needToPrecifyPercentLender,
  isVisible = true,
  handleChange,
  isExceeding,
  fieldName
}) => {
  return (
    isVisible &&
    <>
      <Col xs={24} sm={24} md={24} lg={24}>
        <div className="labelInput">
          <PbrInputMoney
            placeholder={title}
            name={fieldName}
            value={value}
            style={{ fontSize: "15px" }}
            formItemProps={{ label: title }}
            onChange={val => handleChange(val)}
            formWrapper={form}
            disabled={needToPrecifyPercentLender}
          />
          <Slider
            className={`${isExceeding ? "slider-mark-reach-max-price" : ""}`}
            min={minValue}
            max={maxValue}
            value={value}
            onChange={handleChange}
            disabled={needToPrecifyPercentLender}
            step={0.01}
            marks={marks}
          />
        </div>
      </Col>
    </>
  );
}



// WEBPACK FOOTER //
// ./src/components/PricingComponents/SliderMarkComponent/SliderMarkComponent.tsx